import styled from "@emotion/styled";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const InfoBannerContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.selected,
	display: "flex",
	gap: "16px",
	alignItems: "center",
	alignText: "center",
	padding: "14px",
	div: {
		":first-child": {
			...theme.project.typography.body.body1,
			fontWeight: 500
		},
		p: {
			...theme.project.typography.body.body2,
			marginTop: 0
		},
		ul: {
			...theme.project.typography.body.body2,
			marginTop: 0
		},
		li: {
			...theme.project.typography.body.body2
		}
	}
}));

export const InfoBannerTitleText = styled.div(({ theme }) => ({
	...theme.project.typography.alert.alertTitle
}));

export const InfoBannerBodyText = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2
}));

export const InfoBannerText = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	color: theme.project.colors.primaryColors.main
}));

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	width: "22px",
	padding: "0px 8px",
	alignSelf: "flex-start"
}));
